import { InputNumber } from "models/packingList";

export const SETTINGS_NUMBER_PLACEHOLDER = "0";

export const toSettingsInputValue = (value: InputNumber): string | number =>
  value != null && Number(value) > 0 ? value : "";

type StuffingFieldValue = { enabled: boolean; value: InputNumber };
type WithStuffing<F extends string> = Record<F, StuffingFieldValue> & { disableStacking?: boolean };

export const applyDisableStacking = <F extends string, T extends WithStuffing<F>>(
  prev: T,
  settingsFields: readonly F[],
  checked: boolean
): T => {
  if (checked) {
    return {
      ...prev,
      disableStacking: true,
      ...Object.fromEntries(settingsFields.map((field) => [field, { ...prev[field], enabled: false, value: 0 }])),
    } as T;
  }
  return { ...prev, disableStacking: false } as T;
};

export const applyStuffingSelect = <F extends string, T extends WithStuffing<F>>(
  prev: T,
  settingsFields: readonly F[],
  entryField: F
): T => {
  const isActive = prev[entryField].enabled;
  return {
    ...prev,
    disableStacking: false,
    ...Object.fromEntries(
      settingsFields.map((field) => {
        const enable = !isActive && field === entryField;
        return [field, { ...prev[field], enabled: enable, value: enable ? prev[field].value : 0 }];
      })
    ),
  } as T;
};
